define.alias("ember-math-helpers/helpers/log10", "media/helpers/log10");